<template>
  <div>
    <ckeditor v-model="contenido_editar" :config="editorConfig"></ckeditor>
    <!-- {{contenido_editar}} -->
  </div>
</template>
<script>
import CKEditor from 'ckeditor4-vue';
import Vue from 'vue'

Vue.use(CKEditor);
export default {
    props: {
        contenidoAEditar: String,
        estilosCssDeContenido: String,
        height: Number,
        width: String,
        margenEnContenido: String
    },
    data() {
        return {
            nombreClaseCssMargen: 'margenPagina',
            editorConfig: {
                height: null,
                width: null,
                contentsCss: '',
                allowedContent: true,
                bodyClass: '',
            }
        }
    },
    methods: {
        obtenerArchivoHtmlDeContenido: function() { debugger
            return new Blob([this.contenido_editar], {type: 'text/html'});
        },
        agregarCssAContenido: function() {
            this.editorConfig.contentsCss = '';
            this.editorConfig.bodyClass = '';
            if(this.margenEnContenido != null && this.margenEnContenido != undefined) {
                const CLASE_CSS_PARA_MARGEN   = `.${this.nombreClaseCssMargen} ${this.margenEnContenido}`;
                this.editorConfig.contentsCss = this.css_contenido + ' ' + CLASE_CSS_PARA_MARGEN;
                this.editorConfig.bodyClass   = this.nombreClaseCssMargen;
            }
            else {
                this.editorConfig.contentsCss = this.css_contenido;
                this.editorConfig.bodyClass   = '';
            }
        }
    },
    created() {
        this.agregarCssAContenido();
        this.editorConfig.height = this.height_editor;
        this.editorConfig.width = this.width_editor;
    },
    watch: {
        estilosCssDeContenido() {
            this.agregarCssAContenido();
        },
        margenEnContenido() {
            this.agregarCssAContenido();
        }
    },
    computed: {
        contenido_editar: {
            get() {
                return this.contenidoAEditar;
            },
            set(val) {
                this.$emit('obtenerContenidoEditado', val);
            }
        },
        css_contenido: {
            get() {
                return this.estilosCssDeContenido;
            },
            set(val) {
                this.$emit('obtenerCssDeContenido', val);
            }
        },
        height_editor: {
            get() {
                return this.height;
            },
            set(val) {
                this.$emit('obtenerHeightEditor', val);
            }
        },
        width_editor: {
            get() {
                return this.width;
            },
            set(val) {
                this.$emit('obtenerWidthEditor', val);
            }
        }
    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SINOJ/Comun/CEditorDeTextoCK.vue